import clubsConfig from '@/config/cancun-clubs-config.json';

const COCO_SLUG = 'coco-bongo-cancun';
const CONFESSIONS_SLUG = 'confessions-cancun';
const MUN_SLUG = 'mun-nightclub-cancun';
const KULTURA_SLUG = 'kultura-restaurant-cancun';
const ILIOS_SLUG = 'ilios-restaurant-cancun';
const ROSANEGRA_SLUG = 'rosa-negra-cancun';
const TABOO_SLUG = 'taboo-cancun';


function slugDecoder(slug) {
  return slug ? slug.split('-')[0] : '';

}

function venueDecoder(slugOrTitle) {
  let venue = '';
  if(slugOrTitle.indexOf('@') > -1) {
    venue = slugOrTitle.split('@')[1];
  } else {
    return  clubsConfig[slugOrTitle];
  }

  const venueMatch = venue.toLowerCase();


  let venueConfigMap = {
    'coco.bongo.cancun': COCO_SLUG,
    'confessions': CONFESSIONS_SLUG,
    'taboo':  TABOO_SLUG,
    'kultura': KULTURA_SLUG,
    'ilios': ILIOS_SLUG,
    'rosa.negra': ROSANEGRA_SLUG,
    'mun.cancun': MUN_SLUG,
  }



  for (const key in venueConfigMap) {
    if (venueMatch.match(key)) {
      return clubsConfig[venueConfigMap[key]] || { title: '' };
    }
  }
  console.error('venue decoder: venue not found:' + slugOrTitle );
  return { title: '', address: {} };

}

export { venueDecoder, slugDecoder };
